import { AddProductsAsAlternate } from '../add-product-as-alternate';
interface IProp {
  gridApi?: any;
  numberOfSelected: number;
  isAddToList?: boolean;
  isReverse: boolean;
  listId: string;
  uniqueId: string;
  searchQuery: string;
}

const ActionWhenSelectPartHasMyList: React.FC<IProp> = ({
  gridApi,
  numberOfSelected,
  isAddToList,
  isReverse,
  listId,
  uniqueId,
  searchQuery
}) => {
  return (
    <div className="selected-buttons-wrapper">
      <div className="selected-buttons-content">
        <div className="selected-buttons-floater">
          <div
            className={isAddToList ? 'selected add-products-alternate-to-list-container' : ''}
            id="add-products-alternate-to-list-container"
          >
            {isAddToList && (
              <AddProductsAsAlternate
                numberOfSelected={numberOfSelected}
                gridApi={gridApi}
                isReverse={isReverse}
                listId={listId}
                uniqueId={uniqueId}
                searchQuery={searchQuery}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActionWhenSelectPartHasMyList;
